import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { useWatch } from "react-hook-form";
import { buildSnapshotFromFormValues } from "utils/deliveryNoteHelper";
import DeliveryNoteTemplatePreview from "./DeliveryNoteTemplatePreview";

const DeliveryNoteTemplateLivePreview = ({ control, resolveImage }) => {
  const intl = useIntl();
  const values = useWatch({ control });
  const snapshot = buildSnapshotFromFormValues({ values, intl });

  return (
    <DeliveryNoteTemplatePreview
      snapshot={snapshot}
      resolveImage={resolveImage}
    />
  );
};

DeliveryNoteTemplateLivePreview.propTypes = {
  control: PropTypes.object.isRequired,
  resolveImage: PropTypes.func.isRequired,
};

export default DeliveryNoteTemplateLivePreview;
